// extracted by mini-css-extract-plugin
export default {"flex":"mobile-header_flex__a8i7q","button":"mobile-header_button__sx2fU"};